import filterMatchOptions from "../constants/filterMatchOptions";
import { isDateValid } from "../modules/definition/calendar/dateFunctions";
import { stringFromDate,stringFromDateRange } from "../modules/definition/calendar/dateFunctions/stringFromDate";
import { stringFromTimespan } from "../modules/definition/calendar/dateFunctions/timespanFunctions";
import { getLabelWithUntitled } from "./labelUtils";

const matchLabelForValue = v => (v === filterMatchOptions.ALL ? "All" : v === filterMatchOptions.ANY ? "Any" : "None");

const durationRangeStringBuilder = (earliest, latest) =>
  earliest
    ? latest
      ? `${stringFromTimespan(earliest)} - ${stringFromTimespan(latest)}`
      : `longer than ${stringFromTimespan(earliest)}`
    : latest
      ? `shorter than ${stringFromTimespan(latest)}`
      : "";

const dateRangeStringBuilder = (calendar, earliest, latest) =>
  isDateValid(earliest)
    ? isDateValid(latest)
      ? stringFromDateRange(calendar, earliest, latest, {}, false)
      : `after ${stringFromDate(calendar, earliest)}`
    : isDateValid(latest)
      ? `before ${stringFromDate(calendar, latest)}`
      : "";

const getDurationFilterSubLabel = (filterPart, label) => {
  const rangeStr = durationRangeStringBuilder(filterPart.above, filterPart.below);
  return rangeStr ? (label ? `${label}: ` : "") + rangeStr : rangeStr;
};

const getDateFilterSubLabel = (filterPart, calendar, label) => {
  const rangeStr = dateRangeStringBuilder(calendar, filterPart.above, filterPart.below);
  return rangeStr ? (label ? `${label}: ` : "") + rangeStr : rangeStr;
};

const getStringFilterSubLabel = (filterPart, hideMatchLabel, label) => {
  const str = filterPart.terms.toArray().join(", ");
  return str
    ? (label ? `${label}` : "") +
        (hideMatchLabel ? "" : " (" + matchLabelForValue(filterPart.match) + ") ") +
        (label ? ": " : "") +
        str
    : null;
};

const getBooleanFilterSubLabel = (filterPart, label) => {
  const isGroupChecked = filterPart.expected === true || filterPart.expected === false;
  const isValueChecked = Boolean(filterPart.expected);
  return isGroupChecked ? (label ? `${label}: ` : "") + (isValueChecked ? "Yes" : "No") : null;
};

const getGeneralRangeFilterSubLabel = (above, below, label) =>
  above || below
    ? (label ? `${label}: ` : "") +
      (above && below ? `${above} to ${below}` : above ? `>= ${above}` : below ? `<= ${below}` : null)
    : null;

const getNumericFilterSubLabel = (filterPart, label) =>
  getGeneralRangeFilterSubLabel(filterPart.above, filterPart.below, label);

const getListFilterSubLabel = (filterPart, listOptions, hideMatchLabel, label) => {
  return filterPart && filterPart.terms && filterPart.terms.size > 0
    ? (label ? `${label}` : "") +
        (hideMatchLabel ? "" : " (" + matchLabelForValue(filterPart.match) + ") ") +
        (label ? ": " : "") +
        filterPart.terms
          .map(t => {
            const option = listOptions.find(opt => opt.id === t);
            return getLabelWithUntitled(option ? option.label : "");
          })
          .toArray()
          .join(", ")
    : null;
};

const getTagsFilterSubLabel = (filterPart, tags, hideMatchLabel, label) => {
  return filterPart && filterPart.terms && filterPart.terms.size > 0
    ? (label ? `${label}` : "") +
        (hideMatchLabel ? "" : " (" + matchLabelForValue(filterPart.match) + ") ") +
        (label ? ": " : "") +
        filterPart.terms
          .map(t => tags.get(t))
          .toArray()
          .join(", ")
    : null;
};

/**
 * Cannot handle list filter
 * Property names include: label, summary, tags, date, duration
 * @param {FilterPartRecord} filterPart
 * @param {string} name
 */
const getFilterSubLabelByPropName = (filterPart, name, hideMatchLabel, label) => {
  switch (name) {
    case "label":
    case "summary":
      return getStringFilterSubLabel(filterPart, hideMatchLabel, label);
    case "duration":
      return getDurationFilterSubLabel(filterPart, label);
    default:
      return "";
  }
};

export { getFilterSubLabelByPropName };

export default {
  getDurationFilterSubLabel,
  getDateFilterSubLabel,
  getStringFilterSubLabel,
  getBooleanFilterSubLabel,
  getNumericFilterSubLabel,
  getListFilterSubLabel,
  getTagsFilterSubLabel
};
